var cio_datamodel = require("cio-datamodel");

var drawEllipseDataTo2D = require("./drawEllipseDataTo2D");
var drawRectangleDataTo2D = require("./drawRectangleDataTo2D");
var drawTriangleDataTo2D = require("./drawTriangleDataTo2D");
var drawLineDataTo2D = require("./drawLineDataTo2D");
var drawTextDataTo2D = require("./drawTextDataTo2D");
var drawPathDataTo2D = require("./drawPathDataTo2D");
var drawLogoDataTo2D = require("./drawLogoDataTo2D");

var drawShapeDataTo2D = function(svg, group, data, attrs) {
    if(data instanceof cio_datamodel.EllipseData)
        return drawEllipseDataTo2D(svg, group, data, attrs);
    else if (data instanceof cio_datamodel.RectangleData)
        return drawRectangleDataTo2D(svg, group, data, attrs);
    else if (data instanceof cio_datamodel.TriangleData)
        return drawTriangleDataTo2D(svg, group, data, attrs);
    else if (data instanceof cio_datamodel.LineData)
        return drawLineDataTo2D(svg, group, data, attrs);
    else if (data instanceof cio_datamodel.TextData)
        return drawTextDataTo2D(svg, group, data);
    else if (data instanceof cio_datamodel.PathData)
        return drawPathDataTo2D(svg, group, data, attrs);
    else if (data instanceof cio_datamodel.LogoData)
        return drawLogoDataTo2D(svg, group, data, attrs);
    else if (data instanceof cio_datamodel.PropertyData)
        return drawTextDataTo2D(svg, group, data.textData(), attrs, true);
    else
        console.error("Unknown svg type");
    return svg;
};

module.exports = drawShapeDataTo2D;
